import store from '@/store';

export const CURRENCIES = {
  AWG: 'ƒ', AFN: '؋', AOA: 'Kz', XCD: '$', EUR: '€', ALL: 'L', AED: 'د.إ', ARS: '$', AMD: '֏', USD: '$', AUD: '$', AZN: '₼', BIF: 'Fr', XOF: 'Fr', BDT: '৳', BGN: 'лв', BHD: '.د.ب', BSD: '$', BAM: '', GBP: '£', SHP: '£', BYN: 'Br', BZD: '$', BMD: '$', BOB: 'Bs.', BRL: 'R$', BBD: '$', BND: '$', SGD: '$', BTN: 'Nu.', INR: '₹', BWP: 'P', XAF: 'Fr', CAD: '$', CHF: 'Fr', CLP: '$', CNY: '¥', CDF: 'FC', CKD: '$', NZD: '$', COP: '$', KMF: 'Fr', CVE: 'Esc', CRC: '₡', CUC: '$', CUP: '$', ANG: 'ƒ', KYD: '$', CZK: 'Kč', DJF: 'Fr', DKK: 'kr.', DOP: '$', DZD: 'دج', EGP: 'E£', ERN: 'Nfk', MAD: 'د.م.', MRU: 'UM', ETB: 'Br', FJD: '$', FKP: '£', FOK: 'kr', GEL: '₾', GGP: '£', GHS: '₵', GIP: '£', GNF: 'Fr', GMD: 'D', GTQ: 'Q', GYD: '$', HKD: '$', HNL: 'L', HRK: 'kn', HTG: 'G', HUF: 'Ft', IDR: 'Rp', IMP: '£', IRR: '﷼', IQD: 'ع.د', ISK: 'kr', ILS: '₪', JMD: '$', JEP: '£', JOD: 'JD', JPY: '¥', KZT: '₸', KES: 'Sh', KGS: 'с', KHR: '៛', KID: '$', KRW: '₩', KWD: 'د.ك', LAK: '₭', LBP: 'ل.ل', LRD: '$', LYD: 'ل.د', LKR: 'Rs  රු', LSL: 'L', ZAR: 'Rs', MOP: 'P', MDL: 'L', MGA: 'Ar', MVR: '.ރ', MXN: '$', MKD: 'den', MMK: 'Ks', MNT: '₮', MZN: 'MT', MUR: '₨', MWK: 'MK', MYR: 'RM', NAD: '$', XPF: '₣', NGN: '₦', NIO: 'C$', NOK: 'kr', NPR: '₨', OMR: 'ر.ع.', PKR: '₨', PAB: 'B/.', PEN: 'S/.', PHP: '₱', PGK: 'K', PLN: 'zł', KPW: '₩', PYG: '₲', QAR: 'ر.ق', RON: 'lei', RUB: '₽', RWF: 'Fr', SAR: 'ر.س', SDG: '', SBD: '$', SLL: 'Le', SOS: 'Sh', RSD: 'дин.', SSP: '£', STN: 'Db', SRD: '$', SEK: 'kr', SZL: 'L', SCR: '₨', SYP: '£', THB: '฿', TJS: 'ЅМ', TMT: 'm', TOP: 'T$', TTD: '$', TND: 'د.ت', TRY: '₺', TVD: '$', TWD: '$', TZS: 'Sh', UGX: 'Sh', UAH: '₴', UYU: '$', UZS: "so'm", VES: 'Bs.S.', VND: '₫', VUV: 'Vt', WST: 'T', YER: '﷼', ZMW: 'ZK', ZWB: '$',
};

export const getCurrencySymbol = () => {
  const { currencyCode, currency } = store.getters;

  return CURRENCIES[currencyCode] || currency;
};

export const getMoneyStr = (sum) => {
  const { lang, currency, currencyCode } = store.getters;

  sum = Math.round((+sum || 0) * 100) / 100;

  if (!currencyCode) {
    const sumStr = sum.toLocaleString(lang, {
      minimumFractionDigits: 0,
    });
    return `${sumStr} ${currency}`;
  }

  return sum.toLocaleString(lang, {
    currency: currencyCode,
    style: 'currency',
    minimumFractionDigits: 0,
  });
};
